module.exports = __webpack_public_path__ + "img/by-anywhere.61373700.svg";